module.exports = __webpack_public_path__ + "img/project-info.f972832a.png";